import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom-6';

import TokenView from './TokenViewApp';

import { UnsupportedHeader } from '$HVUI';

const App = () => (
    <Router basename="/t">
        <UnsupportedHeader />
        <TokenView />
    </Router>
);

const container = document.getElementById('react-root');
const root = createRoot(container);

root.render(<App />);
